export const zIndexes = {
  layoutBottomContent: 998,
  outlineSelectButton: 1,
  header: 999,
  modal: 1000,
  pageLoader: 9999,
  paywallVisualGoalComparisonChevron: 1,
  paywallVisualGoalComparisonBodyImage: 2,
}
